/* eslint-disable no-unused-vars */
export enum StepperIndexes {
    questionnairePage = "questionnairePage",
    changePensionQuestionnaireIntroPage = "changePensionQuestionnaireIntroPage",
    introPage = "introPage",
    startPage = "startPage",
    phoneNumberPage = "phoneNumberPage",
    smsVerificationPage = "smsVerificationPage",
    pdfPage = "pdfPage",
    investmentProfile = "investmentProfile",
    sustainabilityPage = "sustainabilityPage",
    changeRequestPage = "changeRequestPage",
    editExistingInvestmentStrategyPage = "editExistingInvestmentStrategyPage",
    editNewInvestmentStrategyPage = "editNewInvestmentStrategyPage",
    changesOverviewPage = "changesOverviewPage",
    whatToChange = "whatToChange",
    whatToChangeInvestmentStrategy = "whatToChangeInvestmentStrategy",
    //specific for change pension constribution
    bankIdentificationPage = "bankIdentificationPage",
    amlIdentificationPage = "amlIdentificationPage",
    amlIdentificationIntroPage = "amlIdentificationIntroPage",
    changeContributionPage = "changeContributionPage",
    changeContributionOverviewPage = "changeContributionOverviewPage",
    changeContributionRecapPage = "changeContributionRecapPage",
    changeContributionRequestSentPage = "changeContributionRequestSentPage",
}
